import {Type} from 'class-transformer';
import {UserDetailsRes} from '../cp';
import {SettingsDetailRes} from '../crm/settings.contract';

export class SetPasswordReq {
    newPassword: string = "";
    requirePasswordChange: boolean = false;
}

export class GenerateTemporaryPasswordReq {
    sendMail: boolean = true;
}

export enum RmEmploymentType {
    Permanent = 1,
    Temporary = 2,
    WorkingStudent = 3,
    Intern = 4,
    Freelancer = 5,
    MiniJob = 6,
    Ausbildung = 7,
    DualStudent = 8,
    MidiJob = 9,
    ShortTermEmployment = 10,
    SeasonalEmployment = 11,
    TemporaryAgencyEmployment = 12,
    ManagingDirector = 13,
    VoluntaryService = 14
}

export enum RmEmploymentWorkScheduleType {
    StandardWeek = 1,
    FixedWeekly = 2,
    RotatingWeeks = 3
}

export class RmEmploymentWorkScheduleRule {
    dayOfWeek: number = 1;
    weekIndex: number = 1;
    targetHours: number = 8;
    allowedStartLocal?: string;
    allowedEndLocal?: string;
}

export enum CompensationType {
    MonthlySalary = 1,
    HourlyRate = 2
}

export enum RmSpecialPaymentType {
    Bonus = 1,
    YearEndParticipation = 2,
    ManagingDirectorParticipation = 3,
    ShareholderParticipation = 4,
    OvertimePayout = 5,
    Other = 99
}

export class AdminUserContractVersionOnboardReq {
    isActive: boolean = true;
    validFrom: any = new Date();
    validTo?: any;
    noticeDate?: any;
    employmentType: RmEmploymentType = RmEmploymentType.Permanent;
    isTemporary: boolean = false;
    temporaryUntil?: any;
    probePeriodUntil?: any;
    weeklyHours: number = 40;
    weeklyWorkingDays: number = 5;
    workScheduleType: RmEmploymentWorkScheduleType = RmEmploymentWorkScheduleType.StandardWeek;
    workScheduleCycleWeeks: number = 1;
    workScheduleAnchorDate?: any;
    workScheduleRules: RmEmploymentWorkScheduleRule[] = [];
    allowWorkTimeOutsideSchedule: boolean = false;
    notifyMissingTimeEntries: boolean = true;
    vacationDaysPerYear: number = 30;
    compensationType: CompensationType = CompensationType.MonthlySalary;
    monthlySalary: number = 0;
    hourlyRate: number = 0;
    currency: string = 'EUR';
    contractDocumentId?: string;
    note?: string;
}


export class AdminUserContractVersionUpdateReq extends AdminUserContractVersionOnboardReq {
    id!: string;
}

export class RmEmploymentContractVersionDetailRes {
    id!: string;
    employmentId!: string;
    versionNo!: number;
    isActive!: boolean;
    validFrom!: any;
    validTo?: any;
    noticeDate?: any;
    employmentType!: RmEmploymentType;
    isTemporary!: boolean;
    temporaryUntil?: any;
    probePeriodUntil?: any;
    weeklyHours!: number;
    weeklyWorkingDays!: number;
    workScheduleType!: RmEmploymentWorkScheduleType;
    workScheduleCycleWeeks!: number;
    workScheduleAnchorDate?: any;
    @Type(() => RmEmploymentWorkScheduleRule)
    workScheduleRules: RmEmploymentWorkScheduleRule[] = [];
    allowWorkTimeOutsideSchedule!: boolean;
    notifyMissingTimeEntries!: boolean;
    vacationDaysPerYear!: number;
    compensationType!: CompensationType;
    monthlySalary?: number;
    hourlyRate?: number;
    currency!: string;
    contractDocumentId?: string;
    note?: string;
    isCurrent!: boolean;
    created!: any;
}

export class RmEmploymentSpecialPaymentCreateReq {
    paymentDate: any = new Date();
    amount: number = 0;
    currency: string = 'EUR';
    type: RmSpecialPaymentType = RmSpecialPaymentType.Bonus;
    overtimeHours?: number;
    projectId?: number;
    reason?: string;
    note?: string;
}

export class RmEmploymentSpecialPaymentUpdateReq extends RmEmploymentSpecialPaymentCreateReq {
    id!: string;
}

export class RmEmploymentSpecialPaymentDetailRes {
    id!: string;
    employmentId!: string;
    paymentDate!: any;
    amount!: number;
    currency!: string;
    type!: RmSpecialPaymentType;
    overtimeHours?: number;
    projectId?: number;
    projectName?: string;
    reason?: string;
    note?: string;
    created!: any;
}

export class RmEmploymentDetailRes {
    id!: string;
    userId!: number;
    created!: any;
    @Type(() => RmEmploymentContractVersionDetailRes)
    currentContractVersion?: RmEmploymentContractVersionDetailRes;

    @Type(() => RmEmploymentContractVersionDetailRes)
    contractVersions: RmEmploymentContractVersionDetailRes[] = [];

    @Type(() => RmEmploymentSpecialPaymentDetailRes)
    specialPayments: RmEmploymentSpecialPaymentDetailRes[] = [];
}

export class AdminUserDetailRes {
    @Type(() => UserDetailsRes)
    user!: UserDetailsRes;

    @Type(() => SettingsDetailRes)
    settings!: SettingsDetailRes;

    @Type(() => RmEmploymentDetailRes)
    employment?: RmEmploymentDetailRes | null;
}

export class AdminUserEmploymentOnboardReq {
    userId: number = 0;
    contractVersion: AdminUserContractVersionOnboardReq = new AdminUserContractVersionOnboardReq();
}

export class AdminUserEmploymentSaveReq {
    currentContractVersion?: AdminUserContractVersionUpdateReq;
    contractVersion?: AdminUserContractVersionOnboardReq;
    contractVersionDeletes: string[] = [];
    specialPaymentCreates: RmEmploymentSpecialPaymentCreateReq[] = [];
    specialPaymentUpdates: RmEmploymentSpecialPaymentUpdateReq[] = [];
    specialPaymentDeletes: string[] = [];
}

export class AdminUserOnboardReq {
    title?: string;
    salutation!: number;
    givenName!: string;
    lastName!: string;
    birthDate?: any;
    departmentId?: string;
    email!: string;
    phoneNumber?: string;
    language?: string;
    birthCountry?: string;
    profileImageId?: string;
    signatureId?: string;
    password?: string;
    isManagingDirector: boolean = false;
    roleIds: number[] = [];
    employment?: AdminUserEmploymentOnboardReq;
}

export class AdminUserOnboardRes {
    user!: UserDetailsRes;
    @Type(() => SettingsDetailRes)
    settings!: SettingsDetailRes;
    employment?: RmEmploymentDetailRes;
}
